var treeItem = Vue.component('tree-item', {
  template: '#tree-item-template',
  props: {
    item: Object,
    make_folder: Boolean,
    parent: Object,
    index: Number
  },
  data: function () {
    return {
      isOpen: true,
      _uid: 'item_' + Math.random().toString(36).substr(2, 9)
    }
  },
  computed: {
    isFolder: function () {
      return this.item.children &&
        this.item.children.length
    }
  },
  methods: {
    toggle: function () {
      if (this.isFolder) {
        this.isOpen = !this.isOpen
      }
    },
    makeFolder: function () {
      this.$emit('make-folder', this.item);
    },
    addItem: function () {
      this.$emit('add-item', this.item);
    },
    addTitleAfter: function (after) {
      this.$emit('add-title-after', after);
    },
    removeItem: function () {
      this.$emit('remove-item', this.item);
    }
  }
});


let research = new Vue({
  data: {
    treeData: [],
    aiLoading: false,
    importLoading: false,
    hasBackup: false,
    previousState: null
  },
  mounted: function () {
    if (!this.treeData || this.treeData.length === 0) { this.treeData = treeData }
  },
  computed: {
    treeDataAsString: function () {
      return JSON.stringify(this.treeData)
    }
  },
  methods: {
    generateAI: function() {
      let nameInput = document.querySelector('#research_name');
      if (!nameInput || !nameInput.value.trim()) {
        alert("Veuillez d'abord saisir le nom de la recherche.");
        return;
      }
      
      this.savePreviousState();
      this.aiLoading = true;
      let title = nameInput.value.trim();
      
      let csrfMeta = document.querySelector('meta[name="csrf-token"]');
      let csrfToken = csrfMeta ? csrfMeta.getAttribute('content') : '';
      
      fetch("/researches/generate_metadata", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-CSRF-Token": csrfToken
        },
        body: JSON.stringify({ name: title })
      })
      .then(async response => {
        const contentType = response.headers.get("content-type") || "";
        if (!response.ok || !contentType.includes("application/json")) {
          if (response.status === 401 || response.url.includes("sign_in")) {
            alert("Votre session a expiré. Veuillez vous reconnecter.");
            window.location.href = "/users/sign_in";
            return null;
          }
          let text = await response.text();
          let msg = "Une erreur est survenue lors de la génération par l'IA.";
          try {
            let jsonErr = JSON.parse(text);
            if (jsonErr.error) msg = jsonErr.error;
          } catch(e) {}
          throw new Error(msg);
        }
        return response.json();
      })
      .then(result => {
        if (!result) return;
        this.applyResultToForm(result);
        this.hasBackup = true;
      })
      .catch(error => {
        if (!error) return;
        console.error(error);
        alert("Une erreur est survenue : " + error.message);
      })
      .finally(() => {
        this.aiLoading = false;
      });
    },

    importFromFile: function(event) {
      let fileInput = event.target;
      if (!fileInput.files || fileInput.files.length === 0) return;
      let file = fileInput.files[0];

      this.savePreviousState();
      this.importLoading = true;

      let formData = new FormData();
      formData.append('file', file);

      let csrfMeta = document.querySelector('meta[name="csrf-token"]');
      let csrfToken = csrfMeta ? csrfMeta.getAttribute('content') : '';

      fetch("/researches/import_file", {
        method: "POST",
        headers: {
          "Accept": "application/json",
          "X-CSRF-Token": csrfToken
        },
        body: formData
      })
      .then(async response => {
        const contentType = response.headers.get("content-type") || "";
        if (!response.ok || !contentType.includes("application/json")) {
          if (response.status === 401 || response.url.includes("sign_in")) {
            alert("Votre session a expiré. Veuillez vous reconnecter.");
            window.location.href = "/users/sign_in";
            return null;
          }
          let text = await response.text();
          let msg = "Une erreur est survenue lors de l'importation du fichier.";
          try {
            let jsonErr = JSON.parse(text);
            if (jsonErr.error) msg = jsonErr.error;
          } catch(e) {}
          throw new Error(msg);
        }
        return response.json();
      })
      .then(result => {
        if (!result) return;
        this.applyResultToForm(result);
        this.hasBackup = true;
      })
      .catch(error => {
        if (!error) return;
        console.error(error);
        alert("Erreur d'importation : " + error.message);
      })
      .finally(() => {
        this.importLoading = false;
        if (fileInput) fileInput.value = '';
      });
    },

    applyResultToForm: function(result) {
      // 0. Update title if returned
      let improvedTitle = result.improved_title || result.name || result.title;
      if (improvedTitle && typeof improvedTitle === 'string' && improvedTitle.trim()) {
        let nameInput = document.querySelector('#research_name');
        if (nameInput) {
          nameInput.value = improvedTitle.trim();
        }
      }

      // 1. Update language
      if (result.language) {
        let lang = String(result.language).toLowerCase();
        if (lang.includes('ar') || lang.includes('عرب')) lang = 'ar';
        else if (lang.includes('fr') || lang.includes('fran')) lang = 'fr';
        else if (lang.includes('en') || lang.includes('ing') || lang.includes('eng')) lang = 'en';

        let langSelect = document.querySelector('select[name="research[language]"]');
        if (langSelect) {
          langSelect.value = lang;
          langSelect.dispatchEvent(new Event('change'));
        }
        let langRadio = document.querySelector('input[name="research[language]"][value="' + lang + '"]');
        if (langRadio) {
          langRadio.checked = true;
          langRadio.dispatchEvent(new Event('change'));
        }
      }
      
      // 2. Update keywords
      if (result.keywords) {
        let keywordsInput = document.querySelector("[data-behavior='tags']");
        if (keywordsInput && keywordsInput.__tagify) {
          keywordsInput.__tagify.removeAllTags();
          keywordsInput.__tagify.addTags(result.keywords);
        } else if (keywordsInput) {
          keywordsInput.value = Array.isArray(result.keywords) ? result.keywords.join(',') : result.keywords;
        }
      }
      
      // 3. Update treeData (topics)
      if (result.topics && Array.isArray(result.topics)) {
        let formattedTopics = result.topics.map(t => {
          if (typeof t === 'string') {
            return { name: t, _destroy: false, children: [] };
          }
          let topicName = typeof t === 'object' && t !== null ? (t.name || t.title || t.topic || '') : String(t || '');
          let children = [];
          let rawChildren = t ? (t.children || t.subtopics || t.sub_topics) : null;
          if (Array.isArray(rawChildren)) {
            children = rawChildren.map(sub => {
              if (typeof sub === 'string') return { name: sub, _destroy: false };
              return { name: sub.name || sub.title || '', _destroy: false };
            });
          }
          return {
            name: topicName,
            _destroy: false,
            children: children
          };
        });
        this.treeData = formattedTopics;
      }
    },

    savePreviousState: function() {
      let nameInput = document.querySelector('#research_name');
      let currentTitle = nameInput ? nameInput.value : '';

      let langVal = '';
      let checkedRadio = document.querySelector('input[name="research[language]"]:checked');
      if (checkedRadio) {
        langVal = checkedRadio.value;
      } else {
        let langSelect = document.querySelector('select[name="research[language]"]');
        if (langSelect) langVal = langSelect.value;
      }

      let currentKeywords = [];
      let keywordsInput = document.querySelector("[data-behavior='tags']");
      if (keywordsInput && keywordsInput.__tagify) {
        currentKeywords = keywordsInput.__tagify.value.map(t => t.value);
      } else if (keywordsInput) {
        currentKeywords = keywordsInput.value;
      }

      this.previousState = {
        title: currentTitle,
        language: langVal,
        keywords: currentKeywords,
        treeData: JSON.parse(JSON.stringify(this.treeData))
      };
    },

    restorePreviousState: function() {
      if (!this.previousState) return;

      // 1. Restore title
      let nameInput = document.querySelector('#research_name');
      if (nameInput) {
        nameInput.value = this.previousState.title;
      }

      // 2. Restore language
      if (this.previousState.language) {
        let langRadio = document.querySelector('input[name="research[language]"][value="' + this.previousState.language + '"]');
        if (langRadio) {
          langRadio.checked = true;
          langRadio.dispatchEvent(new Event('change'));
        } else {
          let langSelect = document.querySelector('select[name="research[language]"]');
          if (langSelect) {
            langSelect.value = this.previousState.language;
            langSelect.dispatchEvent(new Event('change'));
          }
        }
      }

      // 3. Restore keywords
      let keywordsInput = document.querySelector("[data-behavior='tags']");
      if (keywordsInput && keywordsInput.__tagify) {
        keywordsInput.__tagify.removeAllTags();
        if (this.previousState.keywords && this.previousState.keywords.length) {
          keywordsInput.__tagify.addTags(this.previousState.keywords);
        }
      } else if (keywordsInput) {
        keywordsInput.value = Array.isArray(this.previousState.keywords) ? this.previousState.keywords.join(',') : (this.previousState.keywords || '');
      }

      // 4. Restore treeData
      this.treeData = JSON.parse(JSON.stringify(this.previousState.treeData));

      // Reset backup
      this.hasBackup = false;
      this.previousState = null;
    },

    makeFolder: function(item) {
      Vue.set(item, "children", []);
      this.addItem({parent: item});
    },
    addItem: function({parent, after}) {
      let child = {name: ""};

      if (after !== null) {
        parent.children.splice(after + 1, 0, child);
      } else {
        parent.children.push(child);
      }
    },
    removeItem: function(item) {
      Vue.set(item, "_destroy", true);
    },

    addTitle: function() {
      this.treeData.push({
        name: "",
        _destroy: false
      });
    },

    addTitleAfter: function(after) {
      let title = { name: "", _destroy: false };
      this.treeData.splice(after + 1, 0, title);
    }
  }
});

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.research-form-wrapper'))
    research.$mount('.research-form-wrapper')
});
